import { LocalizationService } from '@abp/ng.core';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ca-rtg-icon',
  templateUrl: './rtg-icon.component.html',
  styleUrls: ['./rtg-icon.component.scss', '../conversation-icons.scss'],
  standalone: false,
})
export class RtgIconComponent implements OnInit {
  @Input()
  isRtgEnabled: boolean | null;

  get tooltip(): string {
    let result = '';

    if (this.isRtgEnabled) {
      result = `${this.localizationService.instant('Conversation::RtgEnabled')}`;
    }

    return result;
  }

  constructor(private localizationService: LocalizationService) {}

  ngOnInit(): void {}
}
